/**
 * This is called whrn the data directive is used.
 *
 * @param {object} ele
 * @param {*} data
 * @param {object} parent
 * @returns {void}
 */
export const data = (ele, data, parent) =>
{

};